import { IonSelect, IonSelectOption } from '@ionic/react';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeSelect,
  selectOnChange,
  selectOpened,
  selectOptions,
  selectPlaceHolder,
  selectSelectedOption,
} from '../../redux/slices/select';

const NativeSelect = () => {
  const selectRef = useRef(null);

  const opened = useSelector(selectOpened);
  const options = useSelector(selectOptions);
  const selectedOption = useSelector(selectSelectedOption);
  const dispatch = useDispatch();
  const placeHolder = useSelector(selectPlaceHolder);
  const onChange = useSelector(selectOnChange);

  useEffect(() => {
    if (selectRef?.current) {
      if (opened) {
        selectRef.current?.open();
      } else {
        selectRef.current?.close();
      }
    }
  }, [opened, selectRef?.current]);

  const handleIonChange = (e) => {
    const value = e.detail.value;
    if (onChange) {
      onChange(value);
    }
    dispatch(closeSelect());
  };

  const handleIonDismiss = () => {
    dispatch(closeSelect());
  };

  return (
    <IonSelect
      key={opened ? 'open' : 'closed'}
      onIonChange={handleIonChange}
      ref={selectRef}
      interface='popover'
      placeholder={placeHolder}
      onIonDismiss={handleIonDismiss}
      style={{ display: 'none' }}
      value={selectedOption}
    >
      {options?.map((option) => (
        <IonSelectOption key={option.value} value={option.value}>
          {option.label}
        </IonSelectOption>
      ))}
    </IonSelect>
  );
};

export default NativeSelect;
